module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com.84db59b8.svg";